import { axiosInstanceLive } from 'instance/Axios';
import { handleCatchError } from 'utils/CatchHandler';

const commonEndPoint = 'api/V2/';
const latitude = localStorage.getItem('latitude');
const longitude = localStorage.getItem('longitude');
const merchantCommonPost = async (apiEndPoint, payload) => {
    const endPoint = commonEndPoint + apiEndPoint;
    const token = localStorage.getItem('token');
    let merchantEmpID;
    const isEmployee = localStorage.getItem('isEmployee');
    if (isEmployee === 'true') {
        merchantEmpID = localStorage.getItem('empId');
    }
    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        'Content-Type': 'application/json',
        'X-Latitude': latitude,
        'X-Longitude': longitude
    };
    try {
        const response = await axiosInstanceLive.post(
            endPoint,
            payload,

            {
                headers
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};
const merchantCommonGetRequest = async (apiEndPoint) => {
    const endPoint = commonEndPoint + apiEndPoint;
    const token = localStorage.getItem('token');
    let merchantEmpID;
    const isEmployee = localStorage.getItem('isEmployee');
    if (isEmployee === 'true') {
        merchantEmpID = localStorage.getItem('empId');
    }
    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        'Content-Type': 'application/json',
        'X-Latitude': latitude,
        'X-Longitude': longitude
    };
    try {
        const response = await axiosInstanceLive.get(
            endPoint,

            {
                headers
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};
const handleApiRequest = async (method, endpoint, payload = null) => {
    try {
        const response =
            method === 'GET'
                ? await merchantCommonGetRequest(endpoint, payload) // Pass params for GET
                : await merchantCommonPost(endpoint, payload); // Pass body for POST

        return response;
    } catch (error) {
        console.error('API Error:', error);
        return null;
    }
};
export const GET_API_ENDPOINTS = {
    fetchBankList: 'merchants/bankDetails',
    fetchBankListCd: 'merchants/bankDetailsCD'
    // Add more endpoints as needed
};
export const POST_API_ENDPOINTS = {
    checkTwoFactAuth: 'merchants/twoFactorAuth',

    fingpayAadhaarPay: 'merchants/FinpayAadhaarPay',
    fingPayBalanceEnquiry: 'merchants/FinpayBalanceEnquir',
    fingPayCashWithdrawal: 'merchants/cashwithdrawal',
    fingPayMiniStatement: 'merchants/FinpayMiniStatement',
    kycAuthApi: 'merchants/ekycSendOTP',
    ekycResendOTP: 'merchants/ekycResendOTP',
    ekycVerifyOTP: 'merchants/ekycVerifyOTP',
    EkycAuthBiometric: 'merchants/EkycAuthBiometric',
    viewAEPSpaymentReciept: 'merchants/billpayment/viewAEPSpaymentReciept',
    SdkServiceTokenGenerate: 'moneytransfer/SdkServiceTokenGenerate',
    fetchBiometricDevices: 'moneytransfer/fetchBiomtericDevices',
    cashDeposit: 'merchants/cash-deposit',
    cashDepositReport: 'merchants/cash-deposit-report',
    checkAadhaarStatus: 'moneytransfer/ChecktxnAadharExists',
    updateGstDetails: 'moneytransfer/updateGst'
    // Add more endpoints as needed
};

//GET REQUESTS
export const fetchBankListAPi = async () => {
    //API TO FETCH THE BANK LIST IN AEPS
    const response = await merchantCommonGetRequest(GET_API_ENDPOINTS.fetchBankList)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

//POST REQUESTS
export const checkTwoFactAuthApi = async (payload) => {
    //API FOR TWO FACTOR AUTH
    const response = await merchantCommonPost(POST_API_ENDPOINTS.checkTwoFactAuth, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const fetchAadharPay = async (payload) => {
    //API FOR AADHAAR PAY
    const response = await merchantCommonPost(POST_API_ENDPOINTS.fingpayAadhaarPay, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const fetchBalanceEnquiry = async (payload) => {
    //API FOR BALANCE ENQUIRY
    const response = await merchantCommonPost(POST_API_ENDPOINTS.fingPayBalanceEnquiry, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const fetchCashWithdrewal = async (payload) => {
    //API FOR CASH WITHDREWAL
    const response = await merchantCommonPost(POST_API_ENDPOINTS.fingPayCashWithdrawal, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};

export const fetchMiniStatementApi = async (payload) => {
    //API FOR MINI STATEMENTS
    const response = await merchantCommonPost(POST_API_ENDPOINTS.fingPayMiniStatement, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const fetchKycAuth = async (payload) => {
    //API FOR KYC AUTH
    const response = await merchantCommonPost(POST_API_ENDPOINTS.kycAuthApi, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const fetchKycAuthResent = async (payload) => {
    //API FOR KYC Resent otp
    const response = await merchantCommonPost(POST_API_ENDPOINTS.ekycResendOTP, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const fetchKycAuthVerify = async (payload) => {
    //API FOR KYC verify otp
    const response = await merchantCommonPost(POST_API_ENDPOINTS.ekycVerifyOTP, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const fetchKycAuthFingerVerification = async (payload) => {
    //API FOR KYC Auth
    const response = await merchantCommonPost(POST_API_ENDPOINTS.EkycAuthBiometric, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const viewAEPSpaymentRecieptApi = async (payload) => {
    const response = await merchantCommonPost(POST_API_ENDPOINTS.viewAEPSpaymentReciept, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const sdkInputGeneratorApi = async (payload) => {
    const response = await merchantCommonPost(POST_API_ENDPOINTS.SdkServiceTokenGenerate, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const biometricDevicesApi = async (payload) => {
    const response = await merchantCommonPost(POST_API_ENDPOINTS.fetchBiometricDevices, payload)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return null;
        });
    return response;
};
export const cashDepositApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.cashDeposit, payload);
export const cashDepositBanksApi = () => handleApiRequest('GET', GET_API_ENDPOINTS.fetchBankListCd);
export const cashDepositReport = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.cashDepositReport, payload);
export const checkAadhaarExistApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.checkAadhaarStatus, payload);
export const updateGstDetailsApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.updateGstDetails, payload);
